<template>
	<div class="notopened FlexColumn">
		<!-- 未开通功能 --> 
		<div class="notopened_content FlexColumn">
			<img :src="headurl + '/notopened.png'" alt="">
			<div class="title">
				暂无信息
			</div>
			<div class="text">
				此功能需要额外购买开通才能使用
			</div>
			<div class="opened_btn FlexRow" @click="fn_opened">
				立即开通
			</div>
		</div>
	</div>
</template>

<script>
	
	export default {
		name: 'notopened',
		props: {
			// show: {
			// 	type: Boolean,
			// 	default: false,
			// },
		},
		data() {
			return {
				headurl: 'https://scrm.51kuaiding.com/scrm/hktxcx/home',
			}
		},
		watch: {
			
		},
		methods: {
			fn_opened(){
				
			},
		},
	}
</script>

<style scoped lang="scss">
	.notopened{
		background-color: #fff;
		width: 100%;
		height: calc(100vh - 70px);
		.notopened_content{
			>img{
				width: 282px;
				display: block;
			}
			.title{
				font-size: 18px;
				font-weight: 500;
				color: rgba(80, 80, 80, 1);
				text-align: center;
				vertical-align: top;
				margin: 30px 0 10px 0;
			}
			.text{
				font-size: 14px;
				font-weight: 400;
				color: rgba(150, 150, 150, 1);
				text-align: center;
				vertical-align: top;
				margin-bottom: 70px;
			}
			.opened_btn{
				width: 85px;
				height: 36px;
				border-radius: 2px;
				background: rgba(43, 117, 235, 1);
				cursor: pointer;
				font-size: 14px;
				font-weight: 400;
				color: rgba(255, 255, 255, 1);
				text-align: left;
				vertical-align: top;
			}
		}
	}
	   
</style>